import React from "react";
import { Mic, Newspaper, Presentation, MessageSquare, PenLine, Users, ArrowRight } from "lucide-react";
import Reveal from "./Reveal";
import { INVITE_INTRO, INVITE_FORMATS, INVITE_TOPICS } from "../../data/content";

const ICONS = [Mic, Newspaper, Presentation, MessageSquare, PenLine, Users];

export default function Invite() {
  return (
    <section id="invite" className="relative z-10 py-20 md:py-36">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
          {/* Left: heading */}
          <div className="lg:col-span-5">
            <Reveal>
              <div className="text-[0.7rem] uppercase tracking-[0.24em] text-amber mb-5">
                Media & Appearances
              </div>
              <h2 className="font-display text-4xl md:text-5xl font-bold leading-[1.05] mb-6">
                Invite Me as a <span className="text-amber">Guest</span>
              </h2>
              <p className="text-ink-secondary leading-relaxed mb-8 max-w-md">{INVITE_INTRO}</p>

              <div className="text-[0.7rem] uppercase tracking-[0.18em] text-ink-muted mb-4">
                Topics I speak on
              </div>
              <div className="flex flex-wrap gap-2 mb-9">
                {INVITE_TOPICS.map((t) => (
                  <span
                    key={t}
                    className="rounded-full border border-white/10 bg-surface px-4 py-2 text-sm text-ink-secondary"
                  >
                    {t}
                  </span>
                ))}
              </div>

              <a
                href="#contact"
                data-testid="invite-cta"
                className="group inline-flex items-center gap-2 rounded-full bg-amber px-7 py-3.5 text-sm font-semibold uppercase tracking-[0.12em] text-obsidian hover:bg-amber-hover transition-colors duration-300"
              >
                Send an Invitation
                <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform duration-300" />
              </a>
            </Reveal>
          </div>

          {/* Right: formats */}
          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2 gap-px bg-white/[0.06] rounded-2xl overflow-hidden border border-white/[0.06]">
              {INVITE_FORMATS.map((f, i) => {
                const Icon = ICONS[i % ICONS.length];
                return (
                  <Reveal
                    key={f.num}
                    delay={i * 0.06}
                    className="group relative bg-[#0c0c0b] p-7 hover:bg-surface transition-colors duration-300"
                  >
                    <div className="flex items-center justify-between mb-5">
                      <span className="h-11 w-11 rounded-xl bg-amber/10 text-amber flex items-center justify-center group-hover:bg-amber group-hover:text-obsidian transition-colors duration-300">
                        <Icon size={19} />
                      </span>
                      <span className="font-display text-sm text-ink-muted tracking-[0.1em]">{f.num}</span>
                    </div>
                    <h3 className="font-display text-xl font-bold mb-2">{f.name}</h3>
                    <p className="text-ink-secondary text-[0.92rem] leading-relaxed">{f.desc}</p>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
